/**
 * product-accordion.js
 * Product Accordion Dynamic Content Handler - JavaScript extracted from product-accordion.liquid
 */

(function() {
  'use strict';

  /**
   * Initialize product accordion with variant-specific content
   * @param {string} accordionId - The accordion element ID prefix
   */
  function initProductAccordion(accordionId) {
    const contentEl = document.getElementById(accordionId + '-content');
    const dataEl = document.getElementById(accordionId + '-data');

    if (!contentEl || !dataEl) return;

    let data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Failed to parse accordion data:', e);
      return;
    }

    function parseContent(raw) {
      if (!raw) return '';

      // Handle different metafield types
      if (typeof raw === 'object') {
        if (raw.value) {
          raw = raw.value;
        } else {
          raw = JSON.stringify(raw);
        }
      }

      if (typeof raw !== 'string') {
        raw = String(raw);
      }

      // Split by \n or actual newlines
      const lines = raw.split(/\\n|\n/).filter(line => line.trim());

      if (lines.length === 0) return '';

      let html = '<ul class="accordion-list">';
      lines.forEach(line => {
        // Convert *text* to <strong>text</strong>
        const parsed = line.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');
        html += '<li class="accordion-list-item">' + parsed + '</li>';
      });
      html += '</ul>';

      return html;
    }

    function updateAccordion(variantId) {
      let content = data.variants[variantId];

      // Fallback to product-level metafield
      if (!content) {
        content = data.productFallback;
      }

      // Fallback to manual content
      if (!content) {
        content = data.manualFallback;
      }

      const blockEl = document.getElementById(accordionId + '-block');

      if (content) {
        contentEl.innerHTML = parseContent(content);
        if (blockEl) blockEl.style.display = '';
      } else {
        contentEl.innerHTML = '';
        if (blockEl) blockEl.style.display = 'none';
      }
    }

    // Listen for variant changes (Shopify standard event)
    document.addEventListener('variant:changed', function(e) {
      if (e.detail && e.detail.variant) {
        updateAccordion(e.detail.variant.id);
      }
    });

    // Also listen for URL changes (some themes use this)
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    if (variantParam) {
      updateAccordion(variantParam);
    }

    // Listen for popstate (back/forward navigation)
    window.addEventListener('popstate', function() {
      const params = new URLSearchParams(window.location.search);
      const vid = params.get('variant');
      if (vid) {
        updateAccordion(vid);
      }
    });

    // Observe URL changes for SPAs
    let lastUrl = location.href;
    new MutationObserver(function() {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        const params = new URLSearchParams(window.location.search);
        const vid = params.get('variant');
        if (vid) {
          updateAccordion(vid);
        }
      }
    }).observe(document.body, { subtree: true, childList: true });
  }

  // Export for external use
  window.PivvyAccordion = {
    init: initProductAccordion
  };
})();
